import Queue from "nq";
import { getCurrentUserUseCase } from "../../usecases/user";
import {
  isStrongPassword,
  PASSWORD_TITLE,
} from "../../components/InputFactory/passwordPolicy";

class ResetPresenter {
  constructor(view, updateObjectUseCase) {
    this.view = view;
    this.updateObjectUseCase = updateObjectUseCase;
  }

  componentDidMount() {
    const token = this.view.getToken();
    if (!token) {
      this.view.navigateTo("/expired");
      return;
    }
    this.token = token;
    this.getUser(token);
  }

  async getUser(token) {
    try {
      const user = await getCurrentUserUseCase().execute({ session: token });
      if (user && typeof user === "object" && user.id) {
        this.user = user;
        this.view.setCurrentUsers(user);
        return;
      }
      this.view.navigateTo("/expired");
    } catch (error) {
      console.error(error.message || error);
      this.view.navigateTo("/expired");
    }
  }

  onSubmitPassword(password) {
    const { newPassword, confirmNewPassword } = password || {};
    if (!newPassword || !confirmNewPassword) {
      this.view.showError("Enter and confirm your new password.");
      return;
    }
    if (newPassword !== confirmNewPassword) {
      this.view.showError("Password must be the same.");
      return;
    }
    if (!isStrongPassword(newPassword)) {
      this.view.showError(PASSWORD_TITLE);
      return;
    }
    this.updateUser(newPassword);
  }

  updateUser(newPassword) {
    const user = this.user;
    if (!user?.id) {
      this.view.navigateTo("/expired");
      return;
    }

    this.view.showProgress();
    this.updateObjectUseCase
      .execute(
        "users",
        { id: user.id, password: newPassword, isReset: true },
        { session: this.token },
      )
      .then(() => {
        this.view.hideProgress();
        this.view.showSuccess("Successfully saved!");
        this.view.navigateTo("/signin");
        new Queue.Document()
          .delete("sessions", this.token, { session: this.token })
          .catch((error) => {
            console.error(error.message || error);
          });
      })
      .catch((error) => {
        this.view.hideProgress();
        this.view.showError(error);
      });
  }
}

export default ResetPresenter;
